
<div class="other-options-wrapper" [ngClass]="otherOptionsConfig?.wrapClass">
  <div *ngIf="qprams['method_type']!=='other'" class="other">
    <button class="option" (click)="showOtherOptions()" mat-button>{{otherOptionsConfig?.otherSelectTitle}} <i class="material-icons">arrow_forward_ios</i></button>
  </div>

  <div class="other-list">
    <app-payment-method-list *ngIf="qprams['method_type']==='other' && otherOptionsConfig?.list" [config]="config"
                            [listConfig]="{
                              list: otherOptionsConfig?.list,
                              type: 'button',
                              showInputSearch: true,
                              inputPlaceHolder: otherOptionsConfig?.selectPlaceHolder
                            }"
                            (submitPayment)="dataEmit.emit($event)">
    </app-payment-method-list>
  </div>

</div>